module.exports = __webpack_public_path__ + "static/media/player.72704f17.svg";